import { render, staticRenderFns } from "./DocumentPreview.vue?vue&type=template&id=96b40348&scoped=true"
import script from "./DocumentPreview.vue?vue&type=script&lang=js"
export * from "./DocumentPreview.vue?vue&type=script&lang=js"
import style0 from "./DocumentPreview.vue?vue&type=style&index=0&id=96b40348&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b40348",
  null
  
)

export default component.exports